export default "__VITE_ASSET__CbIG17dg__"